import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import RecordPage from './pages/RecordPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/record-h5" element={<RecordPage />} />
      </Routes>
    </Router>
  );
}

export default App;